import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ComponentBase } from '../component-base.component';
import { Utils } from '../../utils';
import { Location } from '@angular/common';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})

export class NotFoundComponent extends ComponentBase {

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location) {
    super(route, router, location);

  }


  onInit():void {

  }

  submit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/not-found/not-found.component.ts